import React from "react";
import { useTranslation } from "react-i18next";
import { StyledBrowseFilesButton, StyledFileInput } from "./styled";

const BrowseFilesButton = ({
  isProcessing,
  ...props
}: {
  isProcessing?: boolean;
  [prop: string]: any;
}) => {
  const { t } = useTranslation();

  return (
    <StyledBrowseFilesButton type="button" isLoading={isProcessing}>
      {t("browse-your-files")}
      <StyledFileInput type="file" {...props} />
    </StyledBrowseFilesButton>
  );
};

export default BrowseFilesButton;
